import React from 'react';
const BHeader = ({ children }) => (<div className='BlockHeader'>
    {children}
</div>);

export default React.memo(BHeader)